import { get } from "../client";
import { USER_STATS } from "../routes";

export default {
  get: async () => await get(USER_STATS),
};
